import { useLanguage } from '../../../../context/LanguageContext';
import { useGetLanguages } from '../../../../redux/api/translationsAPI';
import { useGetMyDetails } from '../../../../redux/api/users/usersApi';

export function useUserConfigViewComponent() {
  const { data: user } = useGetMyDetails();
  const { data: languages } = useGetLanguages();
  const { currentLanguage } = useLanguage();

  return {
    user,
    language: languages?.find(
      (l) => l.id === (user?.languageId || currentLanguage?.id),
    ),
  };
}
